import React, { useEffect, useRef, useState } from "react";
import "./VideoHero.css";
import posterImg from "../assets/images/plantas-fab-poster.jpg";

export default function VideoHero() {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState("");

  /* ===============================
     FETCH HERO VIDEO FROM API
  ================================ */
  useEffect(() => {
    fetch("https://pharma.accendiatechnologies.com/batterjee/getvideos.php")
      .then(res => res.json())
      .then(data => {
        if (data.status === "success" && data.hero_video) {
          setVideoSrc(data.hero_video);
        }
      })
      .catch(() => {});
  }, []);

  /* ===============================
     SAFE AUTOPLAY
  ================================ */
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !videoSrc) return;

    video.muted = true;
    video.playsInline = true;

    const playVideo = () => {
      video.play().catch(() => {});
    };

    video.addEventListener("canplay", playVideo, { once: true });

    return () => {
      video.removeEventListener("canplay", playVideo);
    };
  }, [videoSrc]);

  return (
    <section className="batterjee-video">
      <video
        ref={videoRef}
        className="batterjee-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        crossOrigin="anonymous"
        poster={posterImg}
      >
        {videoSrc && <source src={videoSrc} type="video/mp4" />}
      </video>

      <div className="cinfa-overlay"></div>

      {/* Static text (optional) */}
      <div className="cinfa-content">
        <h1>Science for a Better Life</h1>
        <p>Innovative healthcare solutions worldwide</p>
      </div>
    </section>
  );
}
